"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetDataQueryMock = exports.useAssetData = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const __1 = require("..");
function useAssetData(did) {
    var _a, _b, _c;
    const locationId = __1.useLocationId();
    const res = client_1.useQuery(ASSET_DATA_QUERY, {
        variables: { locationId, did: did },
        context: { locationId },
        skip: !did,
    });
    return Object.assign(Object.assign({}, res), { data: (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.unit) !== null && _c !== void 0 ? _c : null });
}
exports.useAssetData = useAssetData;
const ASSET_DATA_QUERY = graphql_tag_1.default `
  query GetAssetData($locationId: String!, $did: String!) {
    location(locationId: $locationId) {
      key
      unit(did: $did) {
        key
        name
        unitTypeFixed
      }
    }
  }
`;
function assetDataQueryMock(variables, { name, unitTypeFixed }) {
    return {
        request: { query: ASSET_DATA_QUERY, variables },
        result: {
            data: {
                location: {
                    key: '245450',
                    __typename: 'LocationDTO',
                    unit: {
                        __typename: 'UnitDTO',
                        key: variables.did,
                        name,
                        unitTypeFixed,
                    },
                },
            },
        },
    };
}
exports.assetDataQueryMock = assetDataQueryMock;
//# sourceMappingURL=useAssetData.js.map